/* index.tsx generated by @compiled/babel-plugin v0.29.1 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { useIntl } from 'react-intl-next';
import { IconTile } from '@atlaskit/icon';
// The linting is a false positive, this is a valid import
// eslint-disable-next-line @atlassian/tangerine/import/entry-points
import AkGoalIcon from '@atlaskit/icon/core/goal';
import { isGoalAppearance } from '../types';
import { isMessageId, messages } from './messages';
const appearanceToColorMap = {
  default: 'gray',
  off_track: 'red',
  at_risk: 'yellow',
  on_track: 'green'
};
const appearanceToLabelMap = {
  default: 'GenericIconLabel',
  off_track: 'townsquare.api.goal-state.off-track',
  at_risk: 'townsquare.api.goal-state.at-risk',
  on_track: 'townsquare.api.goal-state.on-track'
};

/**
 * The goal icon component is a wrapper which allows displaying a goal icon based on a semantic
 * appearance prop.
 */
export const GoalIcon = ({
  appearance,
  size,
  localizedLabel
}) => {
  const intl = useIntl();
  const labelMessageId = localizedLabel && isMessageId(localizedLabel === null || localizedLabel === void 0 ? void 0 : localizedLabel.messageId) ? localizedLabel.messageId : appearanceToLabelMap[appearance];
  return /*#__PURE__*/React.createElement(IconTile, {
    size: size,
    icon: AkGoalIcon,
    label: intl.formatMessage(messages[labelMessageId]),
    appearance: appearanceToColorMap[appearance]
  });
};

/**
 * This is here to support backwards compatability with our old API. Where possible, source goal appearance
 * directly from the Atlassian GraphQL API: https://api.atlassian.com/graphql
 *
 * @param statusValue - The status of the goal. If you pass in an unsupported status, it will return the default appearance.
 */
export const normalizeGoalAppearance = statusValue => {
  const appearanceLowercase = statusValue.toLocaleLowerCase();
  return isGoalAppearance(appearanceLowercase) ? appearanceLowercase : 'default';
};